import { addons } from '@storybook/addons';
import myTheme from './theme';

addons.setConfig({
  previewTabs: {
    canvas: null,
    'storybookjs/notes/panel': 'Component Docs',
    'storybook/docs/panel': 'React Usage',
  },
  theme: myTheme
});
